module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.authenticated) ? _c('app-header') : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00282e82!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/Layout.vue
// module id = 477
// module chunks = 6